import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation, Waves, Droplets } from 'lucide-react';
import { openWhatsApp, LOCATION_MESSAGE } from '../utils/whatsapp';
export function Location() {
  const handleWhatsAppLocation = () => {
    openWhatsApp(LOCATION_MESSAGE);
  };
  return <section id="ubicacion" className="py-24 bg-white" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-189">
            <h2 className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-190">
              Estamos en El Durazno, Yacanto de Calamuchita
            </h2>
            <p className="text-lg text-charcoal-light mb-8" data-id="element-191">
              Nos encontramos en un entorno privilegiado de las sierras de
              Córdoba, ideal para quienes buscan tranquilidad, naturaleza y
              descanso. La ubicación de Cabañas El Mirador combina paisaje,
              comodidad y cercanía a atractivos de la zona.
            </p>

            <div className="flex flex-wrap gap-3 mb-8" data-id="element-192">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-sand-light rounded-full text-charcoal font-medium border border-olive/10" data-id="element-193">
                <Waves size={18} className="text-olive" data-id="element-194" />
                Río a 300 m
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-sand-light rounded-full text-charcoal font-medium border border-olive/10" data-id="element-195">
                <Droplets size={18} className="text-olive" data-id="element-196" />
                Termas a 800 m
              </span>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-197">
              <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-earth text-white rounded-lg font-medium hover:bg-earth-dark transition-colors" data-id="element-198">
                <Navigation size={20} data-id="element-199" />
                Cómo llegar
              </a>
              <button onClick={handleWhatsAppLocation} className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-olive text-olive rounded-lg font-medium hover:bg-olive hover:text-white transition-colors" data-id="element-200">
                <MapPin size={20} data-id="element-201" />
                Solicitar ubicación
              </button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2 w-full h-[400px] bg-sand rounded-2xl overflow-hidden shadow-lg relative" data-id="element-202">
            {/* Placeholder for Map - using a static map image or iframe */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108392.68413868664!2d-64.8436444!3d-32.0664444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95d2c1c0b0b0b0b1%3A0x1b0b0b0b0b0b0b0b!2sEl%20Durazno%2C%20C%C3%B3rdoba!5e0!3m2!1ses!2sar!4v1620000000000!5m2!1ses!2sar" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" title="Ubicación Cabañas El Mirador" className="grayscale-[20%] contrast-125" data-id="element-203"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}